module.exports = __webpack_public_path__ + "static/media/notification.876527a4.svg";